import { useState, useEffect } from 'react';
import Loading from './Loading';
import { Link, useNavigate } from 'react-router-dom';
import AuthService from '../hooks/AuthService';

const Sidebar = ({ data }) => {

    const navigate = useNavigate();

    const tabs = [
        { id: 'contact-all', label: 'All', active: true },
        // { id: 'contact-new', label: 'New' },
        // { id: 'contact-favorites', label: 'Favorites' },
    ];


    const dropdownOptions = (clone = {}) => {

        const options = [
            {
                label: 'View Family Tree',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-diagram-2" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 5 7h2.5V6A1.5 1.5 0 0 1 6 4.5zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zM3 11.5A1.5 1.5 0 0 1 4.5 10h1A1.5 1.5 0 0 1 7 11.5v1A1.5 1.5 0 0 1 5.5 14h-1A1.5 1.5 0 0 1 3 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 9 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" />
                    </svg>
                ),
                action: `/family-tree/${clone?._id}`,

            },
            {
                type: 'divider',
            },
            {
                label: 'Send Message',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chat" viewBox="0 0 16 16">
                        <path d="M2.678 11.894a1 1 0 0 1 .287.801 11 11 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8 8 0 0 0 8 14c3.996 0 7-2.807 7-6s-3.004-6-7-6-7 2.808-7 6c0 1.468.617 2.83 1.678 3.894m-.493 3.905a22 22 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a10 10 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105" />
                    </svg>
                ),
                action: `/chat/${clone?._id}`,
            },
            {
                type: 'divider',
            },
            {
                label: 'Edit Profile',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pen" viewBox="0 0 16 16">
                        <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z" />
                    </svg>
                ),
                action: `/edit-clone/${clone?._id}`,
            },
            {
                label: 'Add Memory',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar-plus" viewBox="0 0 16 16">
                        <path d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7" />
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>
                ),
                action: `/add-memory/${clone?._id}`,
            },
        ]

        return options

    };

    const [search, setSearch] = useState('');
    const [filteredClones, setFilteredClones] = useState(data?.clones || []);

    useEffect(() => {
        if (search.trim() === '') {
            setFilteredClones(data?.clones || []);
        } else {
            const filtered = data?.clones?.filter(clone =>
                clone?.data?.name?.toLowerCase().includes(search.toLocaleLowerCase())
            );
            setFilteredClones(filtered || []);
        }
    }, [search, data?.clones]);



    useEffect(() => {
        if (!AuthService.isAuthenticated()) {
            AuthService.logout(navigate);
        }
    }, [navigate]);


    return (
        <>
            {
                data?.clones?.length > 0 ? (
                    <div className="tyn-aside tyn-aside-base sidebar">
                        <div className="tyn-aside-head">
                            <div className="tyn-aside-head-text">
                                <h3 className="tyn-aside-title tyn-title">Clone List</h3>
                                <span className="tyn-subtext">
                                    {`${data?.clones?.length || 0} ${data?.clones?.length === 1 ? 'Clone' : 'Clones'}`}
                                </span>
                            </div>
                            <div className="tyn-aside-head-tools">
                                <ul className="tyn-list-inline gap gap-3">
                                    <li>
                                        <button className="btn btn-icon btn-light btn-md btn-pill">
                                            <Link className="btn btn-icon btn-light btn-md btn-pill" to={"/add-clone"} aria-label='Go to add new clone page'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                                </svg>
                                            </Link>
                                        </button>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        <div className="tyn-aside-row pt-0">
                            <ul className="nav nav-tabs nav-tabs-line">
                                {tabs.map((tab) => (
                                    <li className="nav-item" key={tab.id} >
                                        <button className={`nav-link ${tab.active ? 'active' : ''}`} data-bs-toggle="tab" data-bs-target={`#${tab.id}`} type="button">
                                            {tab.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="tyn-aside-body" data-simplebar>
                            <div className="tyn-aside-search pt-2">
                                <div className="form-group tyn-pill">
                                    <div className="form-control-wrap">
                                        <div className="form-control-icon start">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                            </svg>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            id="search"
                                            placeholder="Search clone / chat"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="tab-content">
                                <div className="tab-pane show active" id="contact-all" tabIndex="0" role="tabpanel">
                                    <Loading status={data?.loading}>
                                        {filteredClones.length > 0 ? (
                                            <ul className="tyn-aside-list">
                                                {filteredClones.map((clone, index) => (
                                                    <li key={clone?.data?._id || `clone-${index}`} className={`tyn-aside-item js-toggle-main ${data?.currentClone?._id === clone?._id ? "active" : ""}`}>
                                                        <div className="tyn-media-group">
                                                            <div
                                                                className="tyn-media tyn-size-lg"
                                                                onClick={() => { data?.setCurrentClone(clone), data?.setMobileActive(true) }}
                                                            >
                                                                <img src={clone?.data?.picture?.media || '/images/avatar/avatar-default.jpg'} alt={clone?.data?.name} />
                                                            </div>
                                                            <div className="tyn-media-col">
                                                                <div
                                                                className="tyn-media-row"
                                                                style={{width:"80%", height:"44px"}}
                                                                onClick={() => { data?.setCurrentClone(clone), data?.setMobileActive(true) }}>
                                                                    <h6 className="name text-capitalize">{clone?.data?.name} {clone?.data?.surname}</h6>
                                                                </div>
                                                            </div>
                                                            <div className="tyn-media-option tyn-aside-item-option">
                                                                <ul className="tyn-media-option-list">
                                                                    <li className="dropdown">
                                                                        <div className="btn btn-icon btn-white btn-pill dropdown-toggle" data-bs-toggle="dropdown" data-bs-offset="0,0">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots" viewBox="0 0 16 16">
                                                                                <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
                                                                            </svg>
                                                                        </div>
                                                                        <div className="dropdown-menu dropdown-menu-end">
                                                                            <ul className="tyn-list-links">
                                                                                {dropdownOptions(clone)?.map((option, index) =>
                                                                                    option.type === 'divider' ? (
                                                                                        <li key={index} className="dropdown-divider"></li>
                                                                                    ) : (
                                                                                        <li key={index}>
                                                                                            <Link to={option.action} data-bs-toggle={option.dataToggle || undefined}>
                                                                                                {option.icon}
                                                                                                <span>{option.label}</span>
                                                                                            </Link>
                                                                                        </li>
                                                                                    )
                                                                                )}
                                                                            </ul>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="mt-3 text-muted text-center small">Oops! No clones found.</p>
                                        )}
                                    </Loading>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : ("")
            }
        </>
    )
}

export default Sidebar